import { LineEye } from '@qr-front/icons/line-eye'
import { Button } from '@qr-front/ui/components/Button'
import { useSetAtom } from 'jotai'

import { isPreviewDialogOpenAtom } from '../../generatorState'

export const PreviewButton = () => {
	const setIsPreviewDialogOpen = useSetAtom(isPreviewDialogOpenAtom)

	return (
		<Button
			visual="ghost"
			size="icon-large"
			onClick={() => setIsPreviewDialogOpen(true)}
			className="bg-purple-8 text-blue"
		>
			<LineEye />
		</Button>
	)
}
